import React, { useEffect, useState } from "react";
import { Space } from "antd";
import { LockOutlined } from "@ant-design/icons";
import DataTable from "../../components/Comman/CustomTable/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import { submissionDataUpdateRequestListAction } from "../../actions/admin";
import { formatDateTimeToCST } from "../../utils/comman";
import ConfirmDeleteModal from "../../components/Comman/ConfirmDeleteModal/ConfirmDeleteModal";
import { acceptDataEntryRequests } from "../../actions/user";
import { SmileOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";

const AdminRequests = () => {
  const dispatch = useDispatch<any>();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isModalOpen, setIsModelOpen] = useState<boolean>(false);
  const [unlockingId, setUnlockingId] = useState<string>(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const handleRefresh = useSelector(
    (state: any) => state?.General?.updateListing
  );

  const fetchRequestsList = (params = {}) => {
    setLoading(true);
    dispatch(
      submissionDataUpdateRequestListAction(params, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200) {
          setData(resp.data || []);
          setPagination({
            ...pagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
          });
        }
      })
    );
  };

  useEffect(() => {
    fetchRequestsList({
      page: pagination.current,
      limit: pagination.pageSize,
    });
  }, [pagination?.current, pagination?.pageSize, handleRefresh]);

  const handleTableChange = (newPagination: any) => {
    setPagination({
      ...pagination,
      current: newPagination?.current,
      pageSize: newPagination?.pageSize,
    });
  };

  const handleModelState = (id?: any) => {
    if (id) setUnlockingId(id); // Store the selected user ID
    setIsModelOpen(!isModalOpen);
  };

  const handleReportUnlocking = () => {
    const payload = {
      action: "approve",
      id: unlockingId,
    };
    dispatch(
      acceptDataEntryRequests(payload, (resp: any) => {
        handleModelState();
      })
    );
  };

  const columns = [
    {
      title: "Data User Name",
      dataIndex: ["updatedBy", "name"],
      key: "userName",
    },
    {
      title: "Data User Email",
      dataIndex: ["updatedBy", "email"],
      key: "userEmail",
    },
    {
      title: "Org",
      dataIndex: ["organization", "shortCode"],
      key: "organizationName",
    },
    {
      title: "Submission Data Year",
      dataIndex: "SubmissionData_Year",
      key: "submissionYear",
    },
    {
      title: "Submission Data Period",
      dataIndex: "SubmissionData_Period",
      key: "submissionPeriod",
    },
    {
      title: "Submission Data Value",
      dataIndex: "SubmissionData_Value",
      key: "submissionValue",
    },
    {
      title: "Submission Due On",
      dataIndex: "SubmissionData_Updated",
      key: "submissionDueOn",
      render: (value) => formatDateTimeToCST(value),
    },
    {
      title: "Action",
      key: "action",
      render: (record) => (
        <Space size="middle">
          <span
            style={{ color: "#3DA57F", fontWeight: "bold", fontSize: "20px" }}
          >
            <LockOutlined onClick={() => handleModelState(record?.id)} />
          </span>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {/* <Header /> */}

      <div className="flex justify-between">
        <h1 className="text-3xl font-bold text-left mb-6 text-white">
          Requests
        </h1>
      </div>
      <div className="table-col">
        {/* <DataTable
          columns={columns}
          data={data}
          loading={loading}
          rowKey="id"
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
          }}
          onTableChange={handleTableChange}
        /> */}
      </div>
      {/* {isModalOpen && (
        <ConfirmDeleteModal
          handleConfirmDeleteModel={handleModelState}
          type="reportUnlock"
          handleModelFunction={handleReportUnlocking}
        />
      )} */}

      <Result
        icon={
          <span className="text-[#309d91] text-8xl">
            {/* <span className="text-[#48ba89cc] text-8xl"> */}

            <SmileOutlined />
          </span>
        }
        title={
          <h2 className="text-white text-xl">
            This feature is not available yet !!!
          </h2>
        }
        // extra={<Button type="primary">Next</Button>}
      />
    </div>
  );
};

export default AdminRequests;
